<template>
  <yield title="Merkzettel">
    <loader :working="working"/>

    <h1 class="mb-0" v-if="!working">
      Mein Merkzettel
    </h1>
    <hr class="mb-4 mt-1">

    <div v-if="!working">
      <div v-for="favorite in favorites" :key="favorite.id">
        <post :post="favorite.post" v-on:unfavorited="removePost" v-if="favorite.post"></post>
        <div class="dummy p-2 p-lg-4 mb-2 border mx-n2 mx-lg-0" v-else>
          <div class="float-right btn-link">
            <fa-icon :icon="['fal', 'trash']" size="lg" @click="deleteDead(favorite.postId)" :id="'post-favorite-tooltip-' + favorite.postId"></fa-icon>
            <b-tooltip :target="'post-favorite-tooltip-' + favorite.postId" :title="'Von Merkzettel entfernen'" placement="left" :disabled="$isMobile"></b-tooltip>
          </div>

          <div class="d-flex justify-content-center flex-wrap align-content-center">
            Story nicht mehr verfügbar
          </div>
        </div>
      </div>
    </div>

    <div class="text-center" v-if="!working && favorites.length === 0">
      Dein Merkzettel ist noch leer! Klicke in Nachrichten auf
      &nbsp; <fa-icon :icon="['fal', 'bookmark']" size="lg"></fa-icon> &nbsp;
      um Stories zu speichern.
    </div>
  </yield>
</template>

<script>
  import Yield from '@/vues/helpers/yield.vue';
  import Loader from '@/vues/helpers/loader.vue';
  import Post from '../posts/post.vue';

  export default {
    name: 'Favorites-Index',
    components: { Yield, Loader, Post },
    data () {
      return {
        working: true,
        favorites: []
      };
    },
    mounted () {
      this.load();
    },
    methods: {
      async load () {
        const res = await this.$http.get('favorites/' + this.$store.getters.deviceId);
        this.favorites = res.body;
        this.working = false;
      },
      removePost (postId) {
        this.favorites = this.favorites.filter((favorite) => favorite.postId !== postId);
      },
      async deleteDead (postId) {
        await this.$http.post('favorites/toggle', {
          deviceId: this.$store.getters.deviceId,
          postId: postId
        });

        this.$store.commit('toggleFavorite', postId);
        this.removePost(postId);
      }
    }
  };
</script>

<style lang="scss" scoped>
  .dummy {
    background-color: rgba(255, 255, 255, 0.4);
    border-style: dashed !important;
    color: #6c757d !important;

    svg {
      cursor: pointer;

      &:hover {
        color: #999;
      }
    }

    div {
      height: 50px;
    }
  }
</style>
